import React from 'react';
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';

const NodeDeleteConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  question,
  subject = '',
  description = '',
  error = '',
  deleting = false,
  cancelLabel = 'Cancel',
  deleteLabel = 'Delete',
  deletingLabel = 'Deleting...',
}) => (
  <Dialog
    open={open}
    onClose={deleting ? undefined : onClose}
    maxWidth="sm"
    fullWidth
  >
    <DialogTitle sx={{ textAlign: 'center' }}>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText component="div">
        <Typography variant="body1" fontWeight="bold" paragraph>
          {question}
        </Typography>
        {subject && (
          <Typography variant="body2" paragraph color="text.secondary">
            {subject}
          </Typography>
        )}
        {description && (
          <Typography variant="body2">
            {description}
          </Typography>
        )}
      </DialogContentText>
      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
    </DialogContent>
    <DialogActions>
      <Button disabled={deleting} onClick={onClose}>
        {cancelLabel}
      </Button>
      <Button
        variant="contained"
        color="error"
        disabled={deleting}
        onClick={onConfirm}
        startIcon={deleting ? <CircularProgress size={16} color="inherit" /> : null}
      >
        {deleting ? deletingLabel : deleteLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default NodeDeleteConfirmationDialog;
